<template>
	<div style="background-color: #000;">
		<!-- position: fixed;
    bottom: 0;
    width: 100%; -->
		<div class="footers">
			<el-row justify="space-between" :gutter="20">
				<el-col :span="6">
					<router-link to="/homesview/homesview" class="navbar-brand">首页</router-link>
					<!-- <a href="https://www.github.com/vueComponent/pro-layout"></a> -->
				</el-col>
				<el-col :span="6">
					<router-link to="/homesview/cloudcourse" class="navbar-brand">云课程</router-link>
					<!-- <a href="https://www.github.com/vueComponent/ant-design-vue-pro"></a> -->
				</el-col>
				<el-col :span="6">
					<router-link to="/homesview/resource" class="navbar-brand">资源库</router-link>
					<!-- <a href="https://www.github.com/sendya/"></a> -->
				</el-col>
				<el-col :span="6">
					<router-link to="/homesview/trialballoon" class="navbar-brand">试题库</router-link>
					<!-- <a href="https://www.github.com/sendya/">试题库</a> -->
				</el-col>
				<!-- <el-col :span="4"><a href="https://www.github.com/sendya/">金砖大赛</a></el-col> -->
				<!-- <el-col :span="4"><a href="https://www.github.com/sendya/">关于我们</a></el-col> -->
			</el-row>
			<el-divider></el-divider>
		</div>
		<div class="footers" style="padding-bottom: 60px;">
			<el-row :gutter="20">
				<el-col :span="7">
					<el-row>
						<el-col :span="4"><img :src="require('../../images/logo1.png')" alt="" /></el-col>
						<el-col :span="16" :offset="1">
							<div style="display: flex;flex-direction: column;color: #fff;">
								<p style="font-size: 33px;margin: 0;">湖南高铁时代</p>
								<p style="font-size: 12px;">HUNAN RAILWAY HIGH-SPEED ERA</p>
							</div>
						</el-col>
						<el-col :span="2"><el-divider direction="vertical"></el-divider></el-col>
					</el-row>
				</el-col>
				<el-col :span="16">
					<el-row align="middle">
						<el-col :span="3">
							<div @click="goCopy" class="footersicon" style="display: flex;flex-direction: column;color: #fff;">
								<img :src="require('@/images/phone.png')" alt="" />
								<p style="font-size: 12px;">181 7599 9192</p>
								<p style="font-size: 12px;">(24小时在线)</p>
							</div>
						</el-col>
						<el-col :span="3" :offset="1" >
							<div @click="goMaps" class="footersicon" style="display: flex;flex-direction: column;color: #fff;">
								<img :src="require('../../images/address.png')" alt="" />
								<p style="font-size: 12px;">湖南省长沙市长青路大明大道口</p>
							</div>
						</el-col>
						<el-col :span="3" :offset="1">
							<div class="footersicon" style="display: flex;flex-direction: column;color: #fff;">
								<img :src="require('../../images/email.png')" alt="" />
								<p style="font-size: 12px;">hngtsdll@163.com</p>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="footersicon1" style="display: flex;flex-direction: column;color: #fff;">
								<img style="width: 80px;height: 80px;" :src="require('../../images/gzh.jpg')" alt="" />
								<p style="font-size: 12px;margin-top: 12px;">高铁时代微信公众号</p>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="footersicon1" style="display: flex;flex-direction: column;color: #fff;">
								<img :src="require('../../images/ewm1.png')" style="width: 80px; height: 80px;" alt="" />
								<p style="font-size: 12px;margin-top: 12px;">高铁时代公司官网</p>
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	methods: {
		goMaps() {
			window.open(
				'https://ditu.amap.com/search?id=B0J6BUY6KW&city=430105&geoobj=112.292485%7C27.781303%7C114.066241%7C28.637727&query_type=IDQ&query=%E6%B9%96%E5%8D%97%E9%AB%98%E9%93%81%E6%97%B6%E4%BB%A3%E6%95%B0%E5%AD%97%E5%8C%96%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&zoom=10.16'
			);
		},
		goCopy(){
			document.execCommand("18175999192")
			this.$message.success('复制成功')
		}
	},
	
	
	
	
};
</script>

<style lang="less" scoped>
/deep/ .el-col-6 {
	text-align: center;
}

.footers {
	max-width: 1200px;
	margin: auto !important;
	background-color: #000 !important;
	padding-top: 20px;
	// padding-bottom: 60px;
}

.el-divider--vertical {
	height: 6em !important;
}
.footersicon1 {
	align-items: center;
	margin-left: 20px;
	img {
		width: 60px;
		height: 60px;
	}
}

.footersicon {
	cursor: pointer;
	align-items: center;
	img {
		width: 40px;
		height: 40px;
	}
	p {
		overflow: inherit;
		white-space: inherit;
		text-overflow: inherit;
	}
}

.footers a {
	color: #fff !important;
}

.footer {
	width: 100%;
	margin: 0 !important;
}
</style>
